var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    viewBox: "0 0 12 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.754 10.328c-.605 0-1.163-.33-1.479-.847-.356-.584-.356-1.283-.06-1.895l3.919-6.41C4.578.524 5.156 0 5.996 0c.84 0 1.418.524 1.862 1.176l3.899 6.377a1.95 1.95 0 0 1-.047 1.928 1.736 1.736 0 0 1-1.48.847H1.755zM5.996 6.98a.64.64 0 0 1 .639.646.634.634 0 0 1-.64.638.64.64 0 0 1-.644-.638c0-.357.289-.646.645-.646zm0-.638c-.235 0-.403-.195-.43-.43L5.35 3.985c-.034-.33.316-.639.645-.639.33 0 .679.31.639.639l-.216 1.928c-.02.229-.181.43-.423.43zM1.754 9.474h8.477c.316 0 .585-.174.753-.443.195-.323.188-.712.033-1.048l-3.872-6.33c-.275-.403-.618-.8-1.15-.8-.53 0-.88.397-1.155.8L.974 7.983c-.16.342-.168.725.034 1.048.161.269.43.443.746.443z"
  })));
}

export default SvgError;